export default __webpack_public_path__ + "static/reading-e6c9c860479c756ab093f88ac93e7703.png";